import { setOrganisationRoleRanking } from '@infuse/api/iam/organisation';
import { useGenericSetRanking } from '@infuse/iam/role/mutations';

export const useSetOrganisationRoleRanking = () => {
  return useGenericSetRanking({
    apiFn: setOrganisationRoleRanking
  });
};
